// components/NewUserCard.js
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Chip,
  Grid,
  MenuItem,
  Pagination,
  Button,
} from '@mui/material';
import {
  Search,
  LocationOn,
  Favorite, 
} from '@mui/icons-material';
import { ActiveHeartIcon, ChatIcon, NonActiveHeartIcon } from '../../../icons';
import { useEffect, useRef, useState } from 'react';
 import Tooltip from "@mui/material/Tooltip";
 import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { fetchUsersList } from '../../../api/user';
import { timeAgo } from '../../../utils/dateTime';
import { getAvatarByGender } from '../../../utils/CommonUtils';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// Mock users data
const users = [
  {
    id: 1,
    name: "Sarah Johnson, 33",
    location: "New Delhi",
    status: "They say you only get one chance to make...",
    active: "Active 7 hours ago",
   plan: "gold",
    avatar: "/assets/images/user-profile/fancy-images/img5.jpg",
    isOnline: true
  },
  {
    id: 2,
    name: "Alex Thompson, 28",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 2 hours ago",
   plan: "Luxury",
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: true
  },
  {
    id: 3,
    name: "Alex Thompson, 25",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 5 hours ago",
    
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: false
  },
  {
    id: 4,
    name: "Alex Thompson, 25",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 5 hours ago",
    
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: false
  },
  {
    id: 5,
    name: "Alex Thompson, 25",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 5 hours ago",
    
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: false
  },
  {
    id: 6,
    name: "Alex Thompson, 25",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 5 hours ago",
    
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: false
  },
  {
    id: 7,
    name: "Alex Thompson, 25",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 5 hours ago",
    
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: false
  },
  {
    id: 8,
    name: "Alex Thompson, 25",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 5 hours ago",
    
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: false
  },
  {
    id: 9,
    name: "Alex Thompson, 25",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 5 hours ago",
    
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: false
  },
  {
    id: 10,
    name: "Alex Thompson, 25",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 5 hours ago",
    
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: false
  },
  {
    id: 11,
    name: "Alex Thompson, 25",
    location: "Mumbai",
    status: "Love to travel and explore new places...",
    active: "Active 5 hours ago",
    
    avatar: "/assets/images/user-profile/fancy-images/img6.jpg",
    isOnline: false
  }, 
];

const NewUserCard = ({ onSelect, searchQuery, setSearchQuery, onRealUserClick,isShow=true }) => {
  const debounceTimeoutRef = useRef(null);
  const [favorites, setFavorites] = useState({});
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({page:1, isBot: false, gender: "all", sortOrder: "desc", sortBy: "", searchTerm: '' });
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [userData, setUserData] = useState([]);
const cardsPerPage = 25;
  // Filter users based on search query with null checks


  // Prevent form submission on Enter key
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const toggleFavorite = (id) => {
  setFavorites((prev) => ({
    ...prev,
    [id]: !prev[id], // toggle only this user's heart
  }));
};

const handleChangeFilter =(updates={})=>{
  setFilter({...filter,...updates})
}


  const fetchData = async () => {
    try {
      setLoading(true);
      const data = await fetchUsersList({
        filter:{...filter,gender:filter?.gender==="all" ? "" :filter?.gender,profileCompilation:'completed',requestType:"chat_initiate"},
        setUserData,
        page: filter?.page,
        limit: cardsPerPage,
        skip: 0,
        isBot: false,
        searchTerm:filter?.searchTerm || ""
      });
      setTotalUsers(data.totalUsersCount);
      setTotalPages(data.totalPages);
    } catch (err) {
      console.error('Error while loading user data', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [JSON.stringify(filter)]);

  useEffect(() => {
    if (searchQuery === undefined || searchQuery === null) return

    clearTimeout(debounceTimeoutRef.current);

    debounceTimeoutRef.current = setTimeout(() => {
      // fetchData()
      handleChangeFilter({searchTerm:(searchQuery ?? "")?.trim(),page:1})
    }, 300);

    return () => {
      clearTimeout(debounceTimeoutRef.current);
    };
  }, [searchQuery]);

// const handleOnChange = (name,value)=>{
//   setFilter({...filter,[name]:value})
// }

  return (
    <>
    {
      isShow ? 
    <Box sx={{ display: 'flex', flexDirection: 'column', gap:2 }}>
      {/* Search + Dropdowns Row */}
<Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>

  {/* Search Input */}
  <TextField
    fullWidth
    placeholder="Search by Name, Location, or Interests"
    value={searchQuery || ''}
    onChange={(e) => setSearchQuery(e.target.value)}
    onKeyPress={handleKeyPress}
    InputProps={{
      startAdornment: <Search sx={{ color: 'text.secondary', mr: 1 }} />,
    }}
    sx={{
      '& .MuiOutlinedInput-root': {
        borderRadius: 2,
        height: 48,
      },
    }}
  />
{/* Dropdown 1 - Recently */}
<TextField
  select
  label="Sort By"
  defaultValue="recently_joined"
  value={filter?.sortBy}
  onChange={(e)=>handleChangeFilter({"sortBy":e?.target?.value})}
  SelectProps={{
    IconComponent: KeyboardArrowDownIcon, // custom arrow
  }}
  sx={{
    minWidth: 170,
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      height: 48,
    },
    '& svg': {
      fontSize: 24,  // increase or decrease arrow size
      color: '#515151', // custom color
    }
  }}
>
  <MenuItem value="createdAt">Recently Joined</MenuItem>
  <MenuItem value="lastActive">Recently Active</MenuItem>
</TextField>


{/* Dropdown 2 - Gender */}
<TextField
  select
  label="Gender"
  defaultValue="all"
  value={filter?.gender}
  onChange={(e)=>handleChangeFilter({"gender":e?.target?.value})}
  SelectProps={{
    IconComponent: KeyboardArrowDownIcon, // custom arrow
  }}
  sx={{
    minWidth: 130,
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      height: 48,
    },
    '& svg': {
      fontSize: 24,
      color: '#515151',
    }
  }}
>
  <MenuItem value="all">All</MenuItem>
  <MenuItem value="male">Male</MenuItem>
  <MenuItem value="female">Female</MenuItem>
</TextField>  
</Box>


      {/* Users Grid */}
      {
        loading ?
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              Loading...
            </Typography>
          </Box>
          : <>
            <Grid container spacing={2}>
              {userData?.map((user) => {
                if (!user) return null;

                return (
                  <Grid item xs={12} key={user?._id}>
                    <Card 
                    onClick={(e) => {
                       e?.stopPropagation()
                      onSelect && onSelect(user)
                    }}
                      sx={{
                        cursor: 'pointer',
                        borderRadius: 3, boxShadow: 'none',
                        border: '1px solid',
                        borderColor: 'grey.300',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          boxShadow: 3,
                          borderColor: '#BF8500',
                          transform: 'translateY(-2px)',
                        }
                      }}
                    >
                      <CardContent sx={{ p: '16px !important' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flex: 1 }}>
                            {/* Avatar with status */}
                            <Box sx={{ position: 'relative' }}>
                              <img
                                src={user?.profilePicture || getAvatarByGender(user?.gender)}
                                alt={(user?.firstName ?? user?.userName) || 'User'}
                                style={{
                                  width: 60,
                                  height: 60,
                                  borderRadius: '50%',
                                  objectFit: 'cover'
                                }}
                                onError={(e) => {
                                  e.target.src = 'https://via.placeholder.com/72x72?text=User';
                                }}
                              />
                              <Box
                                sx={{
                                  position: 'absolute',
                                  bottom: 2,
                                  right: 2,
                                  width: 16,
                                  height: 16,
                                  bgcolor: user?.isOnLine ? 'success.main' : 'grey.500',
                                  borderRadius: '50%',
                                  border: '2px solid white'
                                }}
                              />
                            </Box>

                            {/* User Info */}
                            <Box sx={{ flex: 1 }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                                <Box  sx={{ display: 'flex', alignItems: 'center',justifyItems:'center', gap: 2, mb: 1 }}>
                                <Typography sx={{ color: '#3C4043', fontSize: '18px', fontWeight: '500', }}>
                                  {(user?.firstName ?? user?.userName) || 'Unknown User'}
                                </Typography>
                               
                                  <Box sx={{color:user?.appInstalled ?  '#108523' : '#fc2323',display: 'flex', alignItems: 'center', gap: 2}}>{user?.appInstalled ? <Box><CheckCircleIcon sx={{color:'#09a323'}}/> App Installed</Box> : <Box><CancelIcon/>App Not Installed</Box>}</Box>
                                </Box>
                                {user?.isSubscribed && (
                                  <Chip
                                    label={!user?.isSubscribed ? "Free" : (user?.subscriptionPlan === "Gold" ? "Gold" : "Luxury")}
                                    size="small"
                                    sx={{
                                      background:
                                        user.subscriptionPlan === "Gold"
                                          ? 'linear-gradient(45deg, #916008, #cc9933)'
                                          : 'linear-gradient(90deg, rgb(176, 37, 33) 0%, rgb(234, 67, 53) 100%)',
                                      color: 'white',
                                      fontSize: '12px',
                                      height: 25
                                    }}
                                  />
                                )}

                              </Box>

                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0 }}>
                                <LocationOn sx={{ fontSize: 16, color: 'text.secondary' }} />
                                <Typography variant="body2" sx={{ fontFamily: 'Neue Montreal, sans-serif', color: 'text.secondary' }}>
                                  {/* {user.location || 'Location not specified'} */}
                                  {(user?.city || user?.state || user?.country) ? [user?.city, user?.state, user?.country].filter(Boolean).join(", ") : 'Location not specified'}
                                </Typography>
                              </Box>

                              {/* <Typography 
                          variant="body2" 
                          sx={{ 
                            fontFamily: 'Neue Montreal, sans-serif', 
                            color: 'text.secondary',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                          }}
                        >
                          {user.status || 'No status available'}
                        </Typography> */}
                            </Box>
                          </Box>

                          {/* Actions */}
                          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 1 }}>
                            <Typography variant="caption" color="text.secondary">
                              {/* {user?.isOnLine || 'Recently active'} */}
                              {user?.isOnLine
                                ? 'Online'
                                : user?.lastActive
                                  ? timeAgo(user?.lastActive)
                                  : 'Recently active'}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              {/* <Tooltip
                                title={(favorites[user?._id] ?? true) ? "Remove from favorites" : "Add to favorites"}
                                arrow
                              >
                                <IconButton size="small" onClick={() => toggleFavorite(user?._id)} >
                                  {(favorites[user?._id] ?? true) ? (
                                    <ActiveHeartIcon style={{ width: '30px', height: '30px' }} />
                                  ) : (
                                    <NonActiveHeartIcon style={{ width: '30px', height: '30px' }} />
                                  )}
                                </IconButton>
                              </Tooltip> */}
                              <Tooltip
                                title="Start Chat"
                                arrow
                              >
                                <IconButton
                                  size="small"
                                  type="button" // Important: prevent form submission 
                                  sx={{ color: 'text.primary' }}
                                >
                                  <ChatIcon />
                                </IconButton>
                              </Tooltip>
                              <Button onClick={(e)=> {
                                e?.stopPropagation()
                                onRealUserClick(true,user)
                                }} sx={{ textTransform: 'capitalize', fontSize: '12px', background: '#BE1F1F', color: '#fff', borderRadius: '20px', px: 2, '&:hover': { background: '#ff4A4A' } }}>View Profile</Button>
                            </Box>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}

            </Grid>
            {userData?.length > 0 && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 3, position: 'sticky', bottom: '0', }}>
                <Pagination
                  count={totalPages}
                  page={filter?.page}
                  onChange={(e, value) => handleChangeFilter({page:value})}
                  // color="primary"
                  size="medium"
                  shape="rounded"
                sx={{
    "& .MuiPaginationItem-root": {
      color: "#000",  
      border: "1px solid #ddd",
    },

    "& .Mui-selected": {
      backgroundColor: "#ff4a4a !important",  
      color: "#fff",
    },

    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "#ffe5e5",
    },
  }} 
                   
                />

              </Box>
            )}
          </>
      }
          


      {/* No results message */}
      {!loading && userData?.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            {searchQuery ? `No users found matching "${searchQuery}"` : 'No users available'}
          </Typography>
        </Box>
      )}
    </Box>
    :<></>
    }
    </>
  );
};

export default NewUserCard;